module.exports = __webpack_public_path__ + "static/media/7.af4c3f88.png";